/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const filter = () =>
  function (day) {
    // Return the ordinal number
    const end = ['th', 'st', 'nd', 'rd'];
    const v = day % 100;
    return day + (end[(v - 20) % 10] || end[v] || end[0]);
  };
module.exports = filter;
